export function asTimezone(s) {
    return s;
}
//# sourceMappingURL=config.js.map